/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

export type VirtualRoomsControllerSubscribeCalendarsV1PathParameters = {
  clientId?: string;
};
